import GlobalMessaging from "./GlobalMessaging";
export default GlobalMessaging;
export { globalMessageHandler } from "./GlobalMessaging";

